import React from 'react';
import './MetaverseRental.css';

function MetaverseRental() {
  return (
    <div className="metaverse-page">
      <div className="metaverse-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="metaverse-title">Rent Your Space in the <span className="cyber-text">Metaverse</span></h1>
          <p className="metaverse-subtitle">Claim your virtual land or host events in private immersive rooms powered by ThrillArts.</p>
          <a href="#rental-options" className="cyber-btn">Explore Options</a>
        </div>
      </div>

      <div className="metaverse-container">
        <section className="metaverse-intro">
          <h2>The Future is Virtual</h2>
          <p>
            Step into the next evolution of digital interaction. Whether you need a private virtual room for meetings, 
            a showcase gallery for your art, or land to build your own custom Metaverse experience, ThrillArts provides 
            the infrastructure and design to make it happen.
          </p>
        </section>

        <section className="metaverse-map-section">
          <h2>Available Metaverse Lots</h2>
          <p>Check out our available land and spawn points below. Red zones indicate lots that are currently for rent.</p>
          <div className="map-container">
            <img src="/images/metaverse-map.png" alt="Map of available lots in the metaverse" className="metaverse-map-image" />
          </div>
        </section>

        <section id="rental-options" className="rental-options-section">
          <h2>Rental Options</h2>
          <div className="rental-grid">
            
            <div className="rental-card">
              <div className="card-icon">🏝️</div>
              <h3>Metaverse Land</h3>
              <p className="rental-price">Starting at $500/mo</p>
              <ul className="rental-features">
                <li>Customizable terrain & environment</li>
                <li>Host up to 100 simultaneous users</li>
                <li>Monetization & commerce tools</li>
                <li>24/7 dedicated server uptime</li>
              </ul>
              <button className="book-btn">Inquire Now</button>
            </div>

            <div className="rental-card premium">
              <div className="card-badge">Most Popular</div>
              <div className="card-icon">🏛️</div>
              <h3>Private Virtual Room</h3>
              <p className="rental-price">Starting at $150/mo</p>
              <ul className="rental-features">
                <li>Pre-designed immersive environments</li>
                <li>Perfect for meetings, parties, or galleries</li>
                <li>Voice and video chat integration</li>
                <li>Custom branding available</li>
              </ul>
              <button className="book-btn">Inquire Now</button>
            </div>

            <div className="rental-card">
              <div className="card-icon">🏢</div>
              <h3>Virtual Storefront</h3>
              <p className="rental-price">Starting at $300/mo</p>
              <ul className="rental-features">
                <li>Sell digital or physical goods</li>
                <li>Interactive 3D product displays</li>
                <li>E-commerce integration</li>
                <li>Analytics & visitor tracking</li>
              </ul>
              <button className="book-btn">Inquire Now</button>
            </div>

          </div>
        </section>

        <section className="contact-metaverse">
          <h2>Ready to Claim Your Space?</h2>
          <p>Contact our Metaverse architects today to discuss your vision and reserve your digital real estate.</p>
          <div className="metaverse-contact-buttons">
            <a href="tel:404-914-6066" className="cyber-btn">📞 Call 404-914-6066</a>
            <a href="/contact-us" className="cyber-btn outline">✉️ Message Us</a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default MetaverseRental;
